import { render, staticRenderFns } from "./correspondent.vue?vue&type=template&id=8ccc54d6&scoped=true"
import script from "./correspondent.vue?vue&type=script&lang=js"
export * from "./correspondent.vue?vue&type=script&lang=js"
import style0 from "./correspondent.vue?vue&type=style&index=0&id=8ccc54d6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccc54d6",
  null
  
)

export default component.exports